import type { ReactElement } from 'react';
import type { AllNounBean } from '@quoruum/frontend-common/oas/gen/quoruum/types.gen';

export type NounCategory = 'Hotel' | 'Airport' | 'Location' | 'Place' | 'Company';

export function nounCategory(type: AllNounBean['type']): NounCategory {
  switch (type) {
    case 'HOTEL':
      return 'Hotel';
    case 'AIRPORT':
      return 'Airport';
    case 'COUNTRY':
    case 'STATE':
    case 'CITY':
      return 'Location';
    case 'COMPANY':
      return 'Company';
    default:
      return 'Place';
  }
}

const svgProps = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  className: 'h-5 w-5',
  'aria-hidden': true,
} as const;

export function NounTypeIcon({ category }: { category: NounCategory }): ReactElement {
  switch (category) {
    case 'Hotel':
      return (
        <svg {...svgProps}>
          <path d="M2 20v-9a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v9M2 17h20M2 5v15" />
          <path d="M6 9V7a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v2" />
        </svg>
      );
    case 'Airport':
      return (
        <svg {...svgProps}>
          <path d="M2 22h20M3.77 10.77 2 9l2-4.5 1.1.55c.55.28.9.84.9 1.45s.35 1.17.9 1.45L8 8.5l3-6 1.05.53a2 2 0 0 1 1.09 1.52l.72 5.4 3.45 1.73a2.4 2.4 0 0 1 1.5 2.2c0 .6-.5 1.1-1.1 1.1-.2 0-.4-.05-.6-.15L6 11.5l-1.5 1-.73-1.73Z" />
        </svg>
      );
    case 'Location':
      return (
        <svg {...svgProps}>
          <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
          <circle cx="12" cy="10" r="3" />
        </svg>
      );
    case 'Place':
      return (
        <svg {...svgProps}>
          <path d="M3 21h18M5 21V10M9 21V10M15 21V10M19 21V10M2 10l10-7 10 7H2Z" />
        </svg>
      );
    case 'Company':
      return (
        <svg {...svgProps}>
          <path d="M2 21h20M4 21V11h4v10M8 21V4h7v17M15 21V9h5v12M10.5 8h2M10.5 12h2M10.5 16h2M17 13h1M17 17h1" />
        </svg>
      );
  }
}
